
import { Component , Vue , Watch ,Prop} from "vue-property-decorator";
@Component({
	
})
export default class usqModal extends Vue {
    @Prop() private roomData!: any;
    usqData:string = ''//设置优鲜活动code
    isUsqManage:boolean = true // 弹窗boolean
    @Watch('isUsqManage') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'usqManage',val:val})
        }
	}
    isClick = false
    goodsList:any = []
	api:any={
        usqActivityApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/freshGoods/getGoodsByActCode",//导入接龙活动
        pushGoodsApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/freshGoods/submitFreshGoods",//优鲜接龙商品提交
	}
	mounted() {

	}
    setUsq(){
        if (!this.usqData || this.isClick) {
            return false
        }
        this.isClick = true
        let url = `${this.api.usqActivityApi}?code=${this.usqData}`
        this.fetch({
            url: url,
            data:{},
            method: "get",
        }).then((res:any) => {
            this.isClick = false
            this.goodsList = res
        }).catch((err:any)=>{
            this.isClick = false
            this.goodsList = []
            if (err.msg) {
                this.$toast(err.msg)
            }
        })	
    }
    pushGoods(){
        if (this.goodsList.length == 0 || this.isClick) {
            return false
        }
        this.$dialog.confirm({
            title:'是否提交',
            message:'请确认自提商品是否参与此次直播'
        }).then(()=>{
            this.isClick = true
            let url = `${this.api.pushGoodsApi}`
            this.fetch({
                url: url,
                method: "post",
                data:{
                    room_id:this.$route.params.id,
                    total: this.goodsList.length,
                    code:this.usqData
                }
            }).then((res:any) => {
                this.$toast("提交成功")
                setTimeout(() => {
                    this.isClick = false
                    this.isUsqManage = false
                }, 1500);
            }).catch((err:any)=>{
                this.isClick = false
                this.$toast(err.msg)
            })	        
        }).catch(()=>{

        })
    }
    cancel(){
        this.isUsqManage = false
    }
}
